module.exports = __webpack_public_path__ + "img/send.81c54423.svg";